import { Button } from '@repo/ui/button'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@repo/ui/dialog'
import { useT } from '@repo/ui/hooks'
import { FormEvent, MouseEvent as ReactMouseEvent, useCallback } from 'react'

export type ModalOptions = {
  message?: string
  onPrimaryButtonClick: () => void
  onSecondaryButtonClick: () => void
  primaryButtonText?: string
  secondaryButtonText?: string
  title?: string
}

export function PreventLeaveDialog({
  modalHandler: { open, setOpen },
  onPrimaryButtonClick,
  onSecondaryButtonClick,
  ...props
}: ModalOptions & {
  modalHandler: {
    open: boolean
    setOpen: (isOpen: boolean) => void
  }
}) {
  const { t } = useT({ keyPrefix: 'modal.unsavedChanges' })
  const handlePrimaryButtonClick = useCallback(
    (event: ReactMouseEvent<HTMLButtonElement, MouseEvent> | FormEvent<HTMLFormElement>) => {
      event.preventDefault()
      onPrimaryButtonClick()
      setOpen(false)
    },
    [onPrimaryButtonClick],
  )
  const handleSecondaryButtonClick = useCallback(
    (event: ReactMouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.preventDefault()
      onSecondaryButtonClick()
      setOpen(false)
    },
    [onSecondaryButtonClick],
  )
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <form onSubmit={handlePrimaryButtonClick}>
        <DialogContent className="min-w-fit">
          <DialogHeader>
            <DialogTitle>{props.title || t('title')}</DialogTitle>
          </DialogHeader>
          <p>{props.message || t('message')}</p>
          <DialogFooter>
            <div className="flex w-full items-center justify-between gap-2">
              <div>
                <Button onClick={handleSecondaryButtonClick} variant="outline">
                  {props.secondaryButtonText || t('secondaryButtonText')}
                </Button>
              </div>
            </div>
            <Button autoFocus type="submit" onClick={handlePrimaryButtonClick}>
              {props.primaryButtonText || t('primaryButtonText')}
            </Button>
          </DialogFooter>
        </DialogContent>
      </form>
    </Dialog>
  )
}
